import Vue from 'vue';
import Vuex from 'vuex';
import { IUsuarioModule } from './usuario/UsuarioModule';

import { IOrcamentoAutoModule } from './orcamento-auto/OrcamentoAutoModule';
import { IFiltroOrcamentoSolicitadoStore } from './orcamento-auto/FiltroOrcamentoSolicitado';

import { IPrestadorSaudeStore } from './cadastros/saude/PrestadorSaudeStore';
import { IConfiguracaoAgendaSaudeStore } from './cadastros/saude/ConfiguracaoAgendaSaudeStore';

Vue.use(Vuex);

export interface IRootState {
    usuario: IUsuarioModule;
    orcamentoAuto: IOrcamentoAutoModule;
    prestadorSaude: IPrestadorSaudeStore;
    filtroOrcamentoSolicitado: IFiltroOrcamentoSolicitadoStore;
    configuracaoAgendaSaude: IConfiguracaoAgendaSaudeStore;
}

const store = new Vuex.Store<IRootState>({});
export default store;